import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import moment from 'moment'

import * as firebase from "firebase";

//global variable
Vue.prototype.$axios = axios
Vue.prototype.$moment = moment
Vue.prototype.$firebase = firebase

// Vue.prototype.$uriUsuariosApi = 'https://login.cosmic.mx/'
Vue.prototype.$uriUsuariosApi = 'http://login.cosmic.mx/'

Vue.prototype.$Snack = {
  color: 'error',
  mode: 'vertical',
  snackbar: false,
  text: '',
  timeout: 6000,
  x: 'left',
  y: 'top'
}
// global methods

// Vue.prototype.$uriUsuarios = 'http://login.cosmic.mx/login?project=5829EFDC-F7CD-4CF0-854C-EAE507F6CD0C&dev=True'
Vue.prototype.$uriUsuarios = 'http://login.cosmic.mx/login?project=5829EFDC-F7CD-4CF0-854C-EAE507F6CD0C&dev=False'

// Vue.prototype.$uriApi = 'https://localhost:44342/api/'
Vue.prototype.$uriApi = 'https://api.cosmiccontigoweb.cosmic.mx/api/'
Vue.prototype.$uriApImg = 'http://apicontigo.cosmic.mx/FileMessage'

// axios.defaults.baseURL ='https://localhost:44342/'
axios.defaults.baseURL ='https://api.cosmiccontigoweb.cosmic.mx/'

Vue.config.productionTip = true
Vue.config.devtools = true;
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  methods: {
    Mensaje (mensaje, tipo = 'success') {
      console.log(mensaje)
      this.$Snack.text = mensaje
      this.$Snack.color = tipo
      this.$Snack.snackbar = true 
    },
    // isBusy (ocupado) {
    //   this.$esBusy = ocupado
    //   console.log('me.$root.isBusy() ' + ocupado)
    // },
    setLogin (user) {
      this.$isLogin = true
      this.$vUser = user
    }
  }
}).$mount('#app')

//  this.$root.Mensaje(" mensaje global.")
//  this.$root.isBusy(true)




